<template>
  <div class="user-box">    
    <div class="box-photo">
      <img src="static/img/logo-pb.png" class="img-fluid" alt="Imagem responsiva">
    </div>
    <div class="img-slogan">
      <img src="static/img/slogan.png" class="img-fluid" alt="Imagem responsiva">      
    </div>

    

    <div class="info">
      <div class="col-lg-2 "><i class="ti-user"></i></div>
      <div class="col-lg-8 ">{{usuario}}</div>
      <div class="col-lg-2 ">
        <a data-toggle="collapse" @click="toggleMenu" href="javascript:void(0)">
          <span>
            <b class="caret"></b>
          </span>
        </a>
      </div>  
        
      <div class="clearfix"></div>
      <div>
        <el-collapse-transition>
          <ul class="nav menu-config" v-show="!isClosed" >
            <li>
              <a href="https://www.youtube.com/watch?v=ao2ZWuPzTlg&feature=youtu.be" target="_blank">
                <span class="sidebar-mini"><i class="ti-video-clapper"></i></span>
                <span class="sidebar-normal">{{ $t("01") }}</span>
                <div class="sidebar-normal-txt " >
                  <iframe width="80" height="50" style="float: left;margin-right: 5%" src="https://www.youtube.com/embed/ao2ZWuPzTlg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen ></iframe>       
                  <b>{{ $t("02") }}</b> {{ $t("03") }}
                </div>
              </a>
            </li>
            <li>
                <a href="https://www.youtube.com/watch?v=13YuULpgGLM" target="_blank">
                    <span class="sidebar-mini"><i class="ti-video-clapper"></i></span>
                    <span class="sidebar-normal">{{ $t("01") }}</span>
                    <div class="sidebar-normal-txt " style="height: 50px;">
                        <iframe width="80" height="50" style="float: left;margin-right: 5%" src="https://www.youtube.com/embed/13YuULpgGLM" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                        <b>{{ $t("377") }}</b>
                    </div>
                </a>
            </li>
            <li>
                <a href="https://www.youtube.com/watch?v=miiYks25KcM" target="_blank">
                    <span class="sidebar-mini"><i class="ti-video-clapper"></i></span>
                    <span class="sidebar-normal">{{ $t("01") }}</span>
                    <div class="sidebar-normal-txt " style="height: 50px;">
                        <iframe width="80" height="50" style="float: left;margin-right: 5%" src="https://www.youtube.com/embed/miiYks25KcM" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                        <b>{{ $t("378") }}</b>
                    </div>
                </a>
            </li>
            <li>
                <a href="https://www.youtube.com/watch?v=H5njBd3yWzY" target="_blank">
                    <span class="sidebar-mini"><i class="ti-video-clapper"></i></span>
                    <span class="sidebar-normal">{{ $t("01") }}</span>
                    <div class="sidebar-normal-txt " style="height: 50px;">
                        <iframe width="80" height="50" style="float: left;margin-right: 5%" src="https://www.youtube.com/embed/H5njBd3yWzY" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                        <b>{{ $t("379") }}</b>
                    </div>
                </a>
            </li>
            <li style="padding:10px 15px;">
              <span class="sidebar-mini"><i class="ti-book"></i></span>
              <span class="sidebar-normal">{{ $t("04") }}</span>
              <a href="http://abinbev.semeq.com.br/FTA_Lubrication_EN.pdf" target="_blank" style="padding:0px 15px;">
                <div class="sidebar-normal-txt">                  
                  {{ $t("05") }}
                </div>
              </a>  
              <a href="http://abinbev.semeq.com.br/SEMEQ_PdM_Technologies.pdf" target="_blank" style="padding:0px 15px;">
                <div class="sidebar-normal-txt">                  
                  {{ $t("06") }}
                </div>
              </a>
              <a href="http://abinbev.semeq.com.br/Semeq_AbInBev_App.pdf" target="_blank" style="padding:0px 15px;">
                <div class="sidebar-normal-txt">                  
                  {{ $t("07") }}
                </div>
              </a>
              <a href="http://abinbev.semeq.com.br/instruction_manual_online_monitoring_system.pdf" target="_blank" style="padding:0px 15px;">
                <div class="sidebar-normal-txt">                  
                  {{ $t("08") }}
                </div>
              </a>        
              <a href="http://abinbev.semeq.com.br/Global_Predictive_Guidelines.xlsx" target="_blank" style="padding:0px 15px;">
                <div class="sidebar-normal-txt">                  
                  {{ $t("09") }}
                </div>
              </a>     
            </li>
            <!-- <li>
              <router-link to="/language">
                <span class="sidebar-mini"><i class="ti-check"></i></span>
                <span class="sidebar-normal">{{ $t("10_1") }}</span>
              </router-link>
            </li> -->
            <li>
              <router-link to="/release">
                <span class="sidebar-mini"><i class="ti-check"></i></span>
                <span class="sidebar-normal">{{ $t("10") }}</span>
              </router-link>
            </li>
          </ul>
        </el-collapse-transition>
      </div>


    <!--<router-link to="/crud/ComponentType">Link externo</router-link>-->  
 
     </div>
    <div class="info" style="height: 38px;padding: 10px 0px;">
      <a :href="link" target="_blank">
        <div class="col-lg-2 "><i class="ti-world"></i></div>
         <div class="col-lg-8 ">{{ $t("11") }}</div>
        <div class="col-lg-2 "></div>
      </a>
    </div>

    <div class="links">
      <router-link to="/home">
        <div style='display: inline;'>
          <popover name="hint" :width="230" event="hover" :pointer='false'>
            <p>{{ $t("12") }}</p>
          </popover>
          <button type="button" class="btn botao-link" @click="linkOffline()" v-bind:class="{ activeOff: activeOff }" v-popover:hint.top>
            {{ $t("13") }}
          </button>
        </div>
      </router-link>
      <router-link to="/online">
        <button type="button" class="btn botao-link" @click="linkOnline()" v-bind:class="{ activeOn: activeOn }">
          {{ $t("14") }}
        </button>
      </router-link>
    </div>
    <div class="finter-online" v-bind:class="{ activeViewOn: activeViewOn }">
      <div class="finter-campo conf-select">
        <label for="inputState">{{ $t("15") }}</label>
          <model-select 
            id='plant_select_on'
            class='select2'
            :options="optionsRegionOn"
            v-model="selected_region_on"
            placeholder="Select a zone">
         </model-select>
      </div>
      <div class="finter-campo conf-select">
        <label for="inputState">{{ $t("16") }}</label>
        <model-select 
          id='plantsOn_select'
          class='select2'
          :options="optionsOn"
          v-model="selected_plants_online"
          placeholder="Select a plant">
        </model-select>
      </div>
      <div class="finter-bt">
        <div><label for="date">{{ $t("17") }}</label></div>
        <input type="text" name="date" v-model="date_year_online" class="display_none">
        <div class="box-button" v-for="item in years" :key="item">       
          <button type="button" class="btn btn-sm" @click="btDateOnline(item)" v-bind:class="{ active: activeYearOnline == item }">{{ item }}</button>
        </div>
      </div>
      <br>
      <br>
      <div class="finter-bt" v-show="viewPeriodOnline">
        <div><label for="date">{{ $t("18") }}</label></div>
        <input type="text" name="period" v-model="period_online" class="display_none">
        <div class="box-button">
          <button type="button" class="btn btn-sm" @click="period3mOnline()" v-bind:class="{ active3mOnline: active3mOnline }">3m</button>
        </div>
        <div class="box-button">
          <button type="button" class="btn btn-sm" @click="period6mOnline()" v-bind:class="{ active6mOnline: active6mOnline }">6m</button>
        </div>
        <div class="box-button">
          <button type="button" class="btn btn-sm" @click="periodytdOnline()" v-bind:class="{ activetdOnline: activetdOnline }">YTD</button>
        </div> 
        <div class="box-button">
          <button type="button" class="btn btn-sm" @click="period1yOnline()" v-bind:class="{ active1yOnline: active1yOnline }">1Y</button>
        </div>          
      </div>

      <!-- MAIS FILTROS-->
      <div class="more_filters">
        <div class="more_filters_title">
          <a data-toggle="collapse" @click="toggleMenuFilters" href="javascript:void(0)">
            <div class="col-lg-2 col-xs-2"><i class="ti-plus"></i></div>
            <div class="col-lg-8 col-xs-8">{{ $t("19") }}</div>
            <div class="col-lg-2 col-xs-2">
                <span>
                  <b class="caret"></b>
                </span>
            </div>
          </a>
        </div>  
        <!--filtros-->  
        <el-collapse-transition>
          <div class="more_filters_box" v-show="!isClosedFilter">
            <div class="finter-campo conf-select">
              <label for="inputState">{{ $t("20") }}</label>
              <model-select 
                id='areaOn_select'
                class='select2'
                :options="optionsAreaOnline"
                v-model="selected_area_online"
                placeholder="Select a area">
              </model-select>
            </div> 
            <!--01-02-22: novo filtro setor (*ele pega os setores normais da arvore, não da família)-->
            <div class="finter-campo conf-select" v-if="active_sector == true">
              <label for="inputState">{{ $t("20-1") }}</label>
              <model-select 
                id='sectorOn_select'
                class='select2'
                :options="optionsSectorOnline"
                v-model="selected_sector_online"
                placeholder="Select a sector">
              </model-select>
            </div>

            <div class="finter-campo conf-select">
              <label for="inputState">{{ $t("21") }}</label>
              <model-select 
                id='machineOn_select'
                class='select2'
                :options="optionsMachineOnline"
                v-model="selected_machine_online"
                placeholder="Select a machine">
              </model-select>
            </div>
            <div class="finter-campo conf-select">
              <label for="inputState">{{ $t("22") }}</label>
              <model-select 
                id='subsetOn_select'
                class='select2'
                :options="optionsComponentOnline"
                v-model="selected_component_online"
                placeholder="Select a subset">
              </model-select>
            </div> 
          </div> 
        </el-collapse-transition>          
      <!--fim MAIS FILTROS-->  
      </div>  
      <!--fim MAIS FILTROS--> 

    </div>
    <div class="filters" v-bind:class="{ activeViewOff: activeViewOff }">
      <div class="finter-campo conf-select">
        <label for="inputState">{{ $t("23") }}</label>
          <model-select 
            id='region_select'
            class='select2'
            :options="optionsRegion"
            v-model="selected_region"
            placeholder="Select a zone">
         </model-select>
      </div>
      <div class="finter-campo conf-select">
        <label for="inputState">{{ $t("24") }}</label>
          <model-select 
            id='plant_select'
            class='select2'
            :options="optionsOff"
            v-model="selected_plants"
            placeholder="Select a plant">
         </model-select>
      </div>
      <div class="finter-bt">
        <div><label for="date">{{ $t("25") }}</label></div>
        <input type="text" name="date" v-model="date_year" class="display_none">
        <div class="box-button" v-for="item in years" :key="item">
          <button type="button" class="btn btn-sm" @click="btDate(item)" v-bind:class="{ active: activeYear == item}">{{ item }}</button>
        </div>
      </div>
      <br>
      <br>
      <div class="finter-bt" v-show="viewPeriod">
        <div><label for="date">{{ $t("18") }}</label></div>
        <input type="text" name="period" v-model="period" class="display_none">
        <div class="box-button">
          <button type="button" class="btn btn-sm" @click="period3m()" v-bind:class="{ active3m: active3m }">3m</button>
        </div>
        <div class="box-button">
          <button type="button" class="btn btn-sm" @click="period6m()" v-bind:class="{ active6m: active6m }">6m</button>
        </div>
        <div class="box-button">
          <button type="button" class="btn btn-sm" @click="periodytd()" v-bind:class="{ activetd: activetd }">YTD</button>
        </div> 
        <div class="box-button">
          <button type="button" class="btn btn-sm" @click="period1y()" v-bind:class="{ active1y: active1y }">1Y</button>
        </div>          
      </div>

      <!-- MAIS FILTROS-->
      <div class="more_filters">
        <div class="more_filters_title">
          <a data-toggle="collapse" @click="toggleMenuFilters" href="javascript:void(0)">
            <div class="col-lg-2 col-xs-2"><i class="ti-plus"></i></div>
            <div class="col-lg-8 col-xs-8">{{ $t("19") }}</div>
            <div class="col-lg-2 col-xs-2">
                <span>
                  <b class="caret"></b>
                </span>
            </div>
          </a>
        </div>  
        <!--filtros--> 
        <el-collapse-transition> 
          <div class="more_filters_box" v-show="!isClosedFilter">
            <div class="finter-campo conf-select">
              <label for="inputState">{{ $t("20") }}</label>
              <model-select 
                id='area_select'
                class='select2'
                :options="optionsArea"
                v-model="selected_area"
                placeholder="Select a area">
              </model-select>
            </div> 
            <!--01-02-22: novo filtro setor (*ele pega os setores normais da arvore, não da família)-->
            <div class="finter-campo conf-select" v-if="active_sector == true">
              <label for="inputState">{{ $t("20-1") }}</label>
              <model-select 
                id='area_select'
                class='select2'
                :options="optionsSector"
                v-model="selected_sector"
                placeholder="Select a sector">
              </model-select>
            </div> 

            <div class="finter-campo conf-select">
              <label for="inputState">{{ $t("21") }}</label>
              <model-select 
                id='machine_select'
                class='select2'
                :options="optionsMachine"
                v-model="selected_machine"
                placeholder="Select a machine">
              </model-select>
            </div>
            <div class="finter-campo conf-select">
              <label for="inputState">{{ $t("22") }}</label>
              <model-select 
                id='subset_select'
                class='select2'
                :options="optionsComponent"
                v-model="selected_component"
                placeholder="Select a subset">
              </model-select>
            </div>
            <div class="finter-campo">        
              <label for="inputState">{{ $t("26") }}</label>
                <model-select 
                  id='technique_select'
                  class='select2'
                  :options="optionsTech"
                  v-model="selected_techniques"
                  placeholder="Select a technique">
               </model-select>
            </div>          
          </div> 
        </el-collapse-transition>  
      <!--fim MAIS FILTROS-->  
      </div>  
      <!--fim MAIS FILTROS--> 

    </div>
    <div class="finter-campo" style="text-align: center;" v-bind:class="{ activeViewOff: activeViewOff }">
      <div class="bt-search">
        <button type="button" class="btn btn-lg btn-block" @click="search()">{{ $t("27") }}</button>
      </div>
    </div>
    <div class="finter-campo" style="text-align: center;" v-bind:class="{ activeViewOn: activeViewOn }">
      <div class="bt-search">
        <button type="button" class="btn btn-lg btn-block" @click="searchOn()">{{ $t("27") }}</button>
      </div>
    </div>
    <!--
    <div class="col-lg-12 col-sm-12">
      <router-link to="/admin/overview" class="btn-magnify">
        <i class="ti-power-off"></i> {{ $t("logout") }}
      </router-link>
    </div>
  -->
  <!--<router-view v-bind:id_filtro="id_filtro" class="layout-view"></router-view>-->

  <div v-if="isAuthenticated" @click="logout" style="margin: 30px 10px; text-align: center;">
    <router-link to="/admin/overview" class="btn-magnify">
      <i class="ti-power-off"></i> {{ $t("logout") }}
    </router-link>
  </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
  import { mapGetters, mapState, mapMutations } from 'vuex'
  import { AUTH_LOGOUT } from '../../../store/actions/auth'
  import axios from 'axios'
  import mixin from '../../../utils/mixin'

  import { ModelSelect } from 'vue-search-select'

  import Popover  from 'vue-js-popover'
import { log } from 'fullcalendar'
  Vue.use(Popover)

 export default {
    components: {
      [CollapseTransition.name]: CollapseTransition,
      ModelSelect: ModelSelect,
    },
    data () {
      return {
        isClosed: true,
        isClosedFilter: true,
        usuario: null,
        optionsOff: [],
        optionsOn: [],
        optionsArea: [],
        optionsSector: [],
        optionsMachine: [],
        optionsComponent: [],
        optionsAreaOnline: [],
        optionsSectorOnline: [],
        optionsMachineOnline: [],
        optionsComponentOnline: [],
        optionsTech: [],
        optionsRegion: [
          {'text': 'ABInBev', 'value': 'GLB'},
          {'text': 'NAZ', 'value': 'NAZ'},
          {'text': 'SAZ', 'value': 'SAZ'},
          {'text': 'MAZ', 'value': 'MAZ'},
          {'text': 'AFR', 'value': 'AFR'},
          {'text': 'EUR', 'value': 'EUR'},
          {'text': 'APAC', 'value': 'APAC'}
        ],
        optionsRegionOn: [
          {'text': 'ABInBev', 'value': ''},
          {'text': 'NAZ', 'value': 'NAZ'},
          {'text': 'SAZ', 'value': 'SAZ'},
          {'text': 'MAZ', 'value': 'MAZ'},
          {'text': 'AFR', 'value': 'AFR'},
          {'text': 'EUR', 'value': 'EUR'},
          {'text': 'APAC', 'value': 'APAC'}
        ],
        selected_area_online: {'text': '', 'value': ''},
        selected_sector_online: {'text': '', 'value': ''},
        selected_machine_online: {'text': '', 'value': ''},
        selected_component_online: {'text': '', 'value': ''},
        selected_area: {'text': '', 'value': ''},
        selected_sector: {'text': '', 'value': ''},
        selected_machine: {'text': '', 'value': ''},
        selected_component: {'text': '', 'value': ''},
        selected_plants_online: {'text': '', 'value': ''},
        selected_plants: {'text': '', 'value': ''},
        selected_region: {'text': 'ABInBev', 'value': 'GLB'},
        selected_region_on: {'text': 'ABInBev', 'value': ''},
        selected_techniques: '',
        date_year: null,
        date_year_online: null,
        text: '',
        period: 'AC',
        period_online: '3',
        viewPeriod: false,
        viewPeriodOnline: false,
        activeBtn: '',
        id_filtro: null,
        activeYear: null,
        active3m: false,
        active6m: false,
        activetd: false,
        active1y: false,
        activeYearOnline: null,
        active3mOnline: false,
        active6mOnline: false,
        activetdOnline: false,
        active1yOnline: false,
        activeOff: false,
        activeOn: false,
        activeViewOff: false,
        activeViewOn: false,
        link: '',
        years: [],
        initSearch: true,
        initSearchOn: true,
        active_sector: false,
      }
    },
    mixins: [mixin],
    mounted () {
      var self = this
      const API = process.env.ROOT_API
      const ENDPOINT = 'v1/users/oracle/me'
      axios
      .get(API + ENDPOINT, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('user-token')
        }
      })
      .then(function (response) {
        var localData = {
          'users': response.data
        }
        localStorage.setItem('users', JSON.stringify(localData))
        localStorage.setItem('username', response.data.usern)
        //console.log(response.data)
        var plant_id = response.data.plant_id
        //console.log('plant_id: ', plant_id)
        self.usuario = response.data.name

        //verificação se a senha cadastrada expirou os 90 dias (Obs: somente para usuários da MAZ)
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth()+1;
        var yyyy = today.getFullYear();
        if(dd<10) {
            dd = '0'+dd
        } 
        if(mm<10) {
            mm = '0'+mm
        } 
        today = yyyy +'-'+ mm +'-'+ dd;
        var created_datetime = response.data.created_datetime //valor que vem do banco

        const timeDiff  = (new Date(today)) - (new Date(created_datetime));
        const days      = timeDiff / (1000 * 60 * 60 * 24)
        //console.log("days: ", days );

        var plant_maz = [9362,9363,9361,10262,10202,10341,10201,10203,13043,13081,13041,13042,13044,14124,14122,14121,13082,12403,14123]

        for (var key in plant_maz) {           
          if(plant_maz[key] == plant_id){
            //console.log('PERTENCE A MAZ!!!', plant_maz[key])
            if(days >= 90){
              alert("Your password has expired, please enter a new password!")
              self.$router.push('/register')

            }
          }
        }
       
        

      })
      .catch((response) => {
        console.log('error ao logar')
        //this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/login'))
      })
      this.activeViewOff = false
      this.activeViewOn = true
      this.activeOff = true
      this.activetd = true
      this.active3mOnline = true

      this.siteOnline()

      let year = new Date().getFullYear()
      while(year != 2017){
        this.years.push(year)
        year--
      }

      let currentYear = new Date().getFullYear();
      this.btDate(currentYear)
      this.btDateOnline(currentYear)
    },
    methods: {
      siteOnline () {    
        var self = this
        let hash = localStorage.getItem('hash')
        self.link = 'https://online.semeq.com.br/login-mysemeq?params=' + hash

      },
      toggleMenu () {
        this.isClosed = !this.isClosed
      },
      toggleMenuFilters () {
        this.isClosedFilter = !this.isClosedFilter
      },
      logout: function () {
        this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/login'))
      },
      loadingPlants: function () {  
        const API = process.env.ROOT_API;
        const ENDPOINT = 'v1/mysemeq-ambev/get-plants'
        let self = this;

        let cached_region = this.getCachedFilter('region');
        if(cached_region){
          this.selected_region = {'text': cached_region, 'value': cached_region}
          this.initSearch = true;
          return;
        }

        axios({method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(resp => {
          var res = resp.data
          var values = [{'text': 'All', 'value': ''}]
          let cached_plant = self.getCachedFilter('plant')
          let option = undefined;
          for (var key in res) {
            option = {'text': res[key].name, 'value': res[key].id}

            if (option.value == cached_plant)
              self.selected_plants = option

            values.push(option)
          }

          self.optionsOff = values

          if(!self.selected_plants.text)
            self.selected_plants = values[0]

          setTimeout(() => {
            if(self.initSearch && !self.getCachedFilter('area') && !self.getCachedFilter('sector') && !self.getCachedFilter('sector') && !self.getCachedFilter('machine') && !self.getCachedFilter('component') && !self.getCachedFilter('technique'))
              self.search();            
          }, 500);

        })
        .catch(err => {
          // from mixin 
          self.ApiErrorHandler(self, error.response.data.status_code);
        })
      },
      loadingTechniques: function () {  
        const API = process.env.ROOT_API;
        const ENDPOINT = 'v1/techniques?lang=EN'
        let self = this;
        axios({method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(resp => {
          var res = resp.data
          var values = [{'text': 'All', 'value': ''}]
          let option = undefined;
          let cached_technique = self.getCachedFilter('technique')

          for (var key in res) {
            option = {'text': res[key].name, 'value': res[key].id}

            if (cached_technique == option.value){
              self.selected_techniques = option.value;
              self.isClosedFilter = false;
            }

            values.push(option);
          }
          self.optionsTech = values

          if(!self.selected_techniques)
              self.selected_techniques = values[0].value

          if(self.initSearch)
            self.search();
        })
        .catch(err => {
          // from mixin
          self.ApiErrorHandler(self, err.response.data.status_code);
        })
      },
      loadingPlantsOn: function () {  
        const API = process.env.ROOT_API;
        const ENDPOINT = `v1/mysemeq-ambev/get-plants-online?region=${this.selected_region_on.value}`

        let cached_region = this.getCachedFilter('region_on');
        if(cached_region){
          this.selected_region_on = {'text': cached_region, 'value': cached_region}
          this.initSearchOn = true;
          return;
        }

        let self = this;
        axios({method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(resp => {
          var res = resp.data
          var values = [{'text': 'All', 'value': ''}]
          let cached_plant = self.getCachedFilter('planta_on')
          let option = undefined;
          for (var key in res) { 
            option = {'text': res[key].name, 'value': res[key].id};          

            if (option.value == cached_plant)
              self.selected_plants_online = option

            values.push(option)
          }
          self.optionsOn = values      

          if(!self.selected_plants_online.text)
            self.selected_plants_online = values[0]

          setTimeout(() => {
            if(self.initSearchOn && !self.getCachedFilter('area_f_on') && !self.getCachedFilter('sector_f_on') && !self.getCachedFilter('machine_on') && !self.getCachedFilter('subset_on'))
              self.searchOn()
          }, 500);

        })
        .catch(err => {
          // from mixin
          self.ApiErrorHandler(self, err.response.data.status_code);
        })
      },
      search: function () {  
        let region = this.selected_region.value == 'GLB' ? '' : this.selected_region.value
        let plant_id = this.selected_plants.value // pode ser vazio
        let plant_name = this.selected_plants.text // pode ser vazio
        let area = this.selected_area.value // pode ser vazio
        //let sector = this.selected_sector.text // pode ser vazio
        let sector = this.selected_sector.text == 'All' ? '' : this.selected_sector.text// pode ser vazio
        let machine = this.selected_machine.value // pode ser vazio
        let component = this.selected_component.value // pode ser vazio
        let technique = this.selected_techniques // pode ser vazio
        let group = 'defect'

        if(this.initSearch){
          let cached_year = localStorage.getItem('year')
          if (cached_year) {
            this.btDate(cached_year);
          }

          let cached_period = localStorage.getItem('period');
          if (cached_period){
            if(cached_period == '3')
              this.period3m()
            else if(cached_period == '6')
              this.period6m()
            else if(cached_period == 'AC')
              this.periodytd()
            else if(cached_period == '12')
              this.period1y()
          }
        }

        let year = this.date_year
        let period = this.period

        this.initSearch = false;

        let filters = {
          "region": region,
          "plant": plant_id,
          "plant_name": plant_name,
          "year":year,
          "period":period,
          "area":area,
          "sector":sector,
          "machine":machine,
          "component":component,
          "technique":technique,
        }

        this.changeFilters(filters);
        
      },
      searchOn: function () {  

        if(!this.selected_region_on.text){
          alert('Please select a region or plant!')
          return false
        }  

        let planta = this.selected_plants_online.value || ''
        let region = this.selected_region_on.value
        let planta_name = this.selected_plants_online.text
        let area = this.selected_area_online.value // pode ser vazio
        //let sector = this.selected_sector_online.value // pode ser vazio
        let sector = this.selected_sector_online.text == 'All' ? '' : this.selected_sector_online.text;// pode ser vazio
        let machine = this.selected_machine_online.value // pode ser vazio
        let component = this.selected_component_online.value // pode ser vazio

        if(this.initSearchOn){
          let cached_year = localStorage.getItem('year_on')
          if (cached_year) {
            this.btDateOnline(cached_year);
          }

          let cached_period = localStorage.getItem('period_on');
          if (cached_period){
            if(cached_period == '3')
              this.period3mOnline()
            else if(cached_period == '6')
              this.period6mOnline()
            else if(cached_period == 'AC')
              this.periodytdOnline()
            else if(cached_period == '12')
              this.period1yOnline()
          }
        }

        let year = this.date_year_online
        let period = this.period_online

        this.initSearchOn = false;

        let filtersOn = {
          "planta": planta,
          'region': region,
          'corp': 1,
          "planta_name": planta_name,
          "year": year,
          "period": period,
          "area_f": area,
          "sector_f": sector,
          "machine": machine,
          "subset": component
        }

        this.changeFiltersOn(filtersOn);        
      },
      linkOffline: function () { 
        var self = this 
        self.activeOff = true
        self.activeOn = false
        self.activeViewOff = false
        self.activeViewOn = true
        self.changeTab('offline')
      },
      linkOnline: function () { 
        var self  = this
        this.activeOff = false
        this.activeOn = true
        this.activeViewOff = true
        this.activeViewOn = false
        self.changeTab('online')
      },
      btDate: function (year) {
        this.activeYear = year
        this.date_year = String(year)

        if(year == new Date().getFullYear()){
          this.viewPeriod = true
        } else {
          this.viewPeriod = false
        }
      },
      period3m: function () {
        this.active3m = true
        this.active6m = false
        this.activetd = false
        this.active1y = false       
        this.period = '3'
      },
      period6m: function () {
        this.active3m = false
        this.active6m = true
        this.activetd = false
        this.active1y = false 
        this.period = '6'
      },
      periodytd: function () {
        this.active3m = false
        this.active6m = false
        this.activetd = true
        this.active1y = false 
        this.period = 'AC'
      },
      period1y: function () {
        this.active3m = false
        this.active6m = false
        this.activetd = false
        this.active1y = true 
        this.period = '12'
      },
      btDateOnline: function (year) {
        this.activeYearOnline = year
        this.date_year_online = String(year)

        if(year == new Date().getFullYear()){
          this.viewPeriodOnline = true
        } else {
          this.viewPeriodOnline = false
        }
      },
      period3mOnline: function () {
        this.active3mOnline = true
        this.active6mOnline = false
        this.activetdOnline = false
        this.active1yOnline = false       
        this.period_online = '3'
      },
      period6mOnline: function () {
        this.active3mOnline = false
        this.active6mOnline = true
        this.activetdOnline = false
        this.active1yOnline = false 
        this.period_online = '6'
      },
      periodytdOnline: function () {
        this.active3mOnline = false
        this.active6mOnline = false
        this.activetdOnline = true
        this.active1yOnline = false 
        this.period_online = 'AC'
      },
      period1yOnline: function () {
        this.active3mOnline = false
        this.active6mOnline = false
        this.activetdOnline = false
        this.active1yOnline = true 
        this.period_online = '12'
      },
      getCachedFilter: function(key) {
        return localStorage.getItem(key);
      },

      ...mapMutations(['changeFilters', 'changeFiltersOn', 'changeTab'])
    },
    computed: {
      ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded', 'getTab']),
      ...mapState({
        authLoading: state => state.auth.status === 'loading',
        name: state => `${state.user.profile.title} ${state.user.profile.name}`
      }),
    },
    watch: {
      getTab: function(){
        if(this.getTab == 'online') {
          this.activeViewOn = false;
          this.activeViewOff = true;
          this.activeOn = true;
          this.activeOff = false;
          if(this.optionsOn.length == 0) { 
            this.loadingPlantsOn() 
          }
        } else if (this.getTab == 'offline') {
          this.activeViewOn = true;
          this.activeViewOff = false;
          this.activeOn = false;
          this.activeOff = true;
          if(this.optionsOff.length == 0) {
            this.loadingPlants()
          }
        }
      },
      selected_region: function(){

        const API = process.env.ROOT_API
        const ENDPOINT = `v1/mysemeq-ambev/get-region-plants?region=${this.selected_region.value}`
        this.optionsOff = []
        this.selected_plants = {value: '', text: ''};
        let self = this
        axios({method: 'GET', url: API + ENDPOINT, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(resp => {
          var res = resp.data
          var values = [{'text': 'All', 'value': ''}]
          let cached_plant = self.getCachedFilter('plant')
          let option = undefined;
          
          for (var key in res) {
            option = {'text': res[key].name, 'value': res[key].id}

            if (res[key].id == cached_plant)
              self.selected_plants = option

            values.push(option)
          }

          self.optionsOff = values

          if(!self.selected_plants.text)
            self.selected_plants = values[0]

          if(self.initSearch && !self.getCachedFilter('area') && !self.getCachedFilter('sector') && !self.getCachedFilter('machine') && !self.getCachedFilter('component') && !self.getCachedFilter('technique')){
            self.search()
          }
        })
        .catch(err => {
          // from mixin
          self.ApiErrorHandler(self, err.response.data.status_code);
        })

      },
      selected_plants: function(){
          const API = process.env.ROOT_API
          const ENDPOINT = `v1/mysemeq-ambev/get-area?id_plant=${this.selected_plants.value || ''}`
          this.optionsArea = []
          let self = this
          axios({method: 'GET', url: API + ENDPOINT, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
          .then(resp => {
            var res = resp.data

            let cached_area = self.getCachedFilter('area')
            let option = undefined;

            var values = [{'text': 'All', 'value': ''}]
            for (var key in res) {   
              option = {'text': res[key].familia_area, 'value': res[key].id_area}

              if(cached_area == option.value){
                self.selected_area = option;
                this.isClosedFilter = false;
              }

              values.push(option)
            }

            self.optionsArea = values

            if(!self.selected_area.text)
              self.selected_area = values[0]

            if(self.initSearch && !self.getCachedFilter('sector') && !self.getCachedFilter('machine') && !self.getCachedFilter('component') && !self.getCachedFilter('technique')){
              self.search();
            }
          })
          .catch(err => {
            // from mixin
            self.ApiErrorHandler(self, err.response.data.status_code);
          })

          //PARA PEGAR OS SETORES, somente com planta ativa, pois sem trava o sistema:
          if(this.selected_plants.value){
            //console.log('ativar setor....')

            this.active_sector = true
         
            const ENDPOINT_SECTOR = `v1/mysemeq-ambev/get-sector?id_plant=${this.selected_plants.value || ''}`
            //console.log('ENDPOINT_SECTOR: ', ENDPOINT_SECTOR)
            this.optionsSector = []
            axios({method: 'GET', url: API + ENDPOINT_SECTOR, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
            .then(resp => {
              var res = resp.data

              let cached_sector = self.getCachedFilter('sector')
              //console.log('111 cached_sector: ', cached_sector)
              let option = undefined;

              var values = [{'text': 'All', 'value': ''}]
              for (var key in res) {   
                option = {'text': res[key].descricao_sector, 'value': res[key].descricao_sector}

                //console.log('cached_sector: ', cached_sector)


                if(cached_sector == option.text){
                  //console.log('option.text 22: ', option)
                  self.selected_sector = option;
                  this.isClosedFilter = false;
                }

                values.push(option)
              }

              self.optionsSector = values

              if(!self.selected_sector.text)
                self.selected_sector = values[0]

              if(self.initSearch && !self.getCachedFilter('sector') && !self.getCachedFilter('machine') && !self.getCachedFilter('component') && !self.getCachedFilter('technique')){
                self.search();
              } 
            })
            .catch(err => {
              // from mixin
              self.ApiErrorHandler(self, err.response.data.status_code);
            })

          }
          else{
            //console.log('desativa setor....')
            this.active_sector = false
          }


      },
      selected_area: function(){
        let self = this
        // self.selected_machine = {'text': 'All', 'value': ''}
        this.optionsMachine = []
        var area_id = this.selected_area.value

        const API = process.env.ROOT_API
        const ENDPOINT = `v1/mysemeq-ambev/get-conjunto?id_plant=${this.selected_plants.value}&id_area=${area_id}`
        this.optionsMachine = []
        
        axios({method: 'GET', url: API + ENDPOINT, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(resp => {
          var res = resp.data

          let cached_machine = self.getCachedFilter('machine')
          let option = undefined;

          var values = [{'text': 'All', 'value': ''}]
          for (var key in res) {
            option = {'text': res[key].familia_conjunto, 'value': res[key].id_conjunto}

            if(cached_machine == option.value){
              self.selected_machine = option
              this.isClosedFilter = false;
            }

            values.push(option)
          }

          self.optionsMachine= values

          if(!self.selected_machine.text)
            self.selected_machine = values[0]

          if(self.initSearch && !self.getCachedFilter('sector') && !self.getCachedFilter('component') && !self.getCachedFilter('technique'))
            self.search();
        })
        .catch(err => {
          // from mixin
          self.ApiErrorHandler(self, err.response.data.status_code);
        })
      },
      selected_machine: function(){
        let self = this
        // self.selected_component = {'text': 'All', 'value': ''}
        this.optionsComponent = []

        var area_id = this.selected_area.value
        var conj_id = this.selected_machine.value

        const API = process.env.ROOT_API
        const ENDPOINT = `v1/mysemeq-ambev/get-equipamento?id_plant=${this.selected_plants.value}&id_area=${area_id}&id_conj=${conj_id}`

        this.optionsComponent = []
        
        axios({method: 'GET', url: API + ENDPOINT, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(resp => {
          var res = resp.data

          let cached_component = self.getCachedFilter('component')
          let option = undefined;

          var values = [{'text': 'All', 'value': ''}]
          for (var key in res) {      
            option = {'text': res[key].familia_equipamento, 'value': res[key].id_equipamento}

            if(cached_component == option.value){
              self.selected_component = option
              this.isClosedFilter = false;
            }

            values.push(option)
          }

          self.optionsComponent= values

          if(!self.selected_component.text)
            self.selected_component = values[0]

          self.loadingTechniques();
          if(self.initSearch && !self.getCachedFilter('sector') && !self.getCachedFilter('technique'))
            self.search();
        })
        .catch(err => {
          // from mixin
          self.ApiErrorHandler(self, err.response.data.status_code);
        })
      },
      selected_region_on: function(){
        const API = process.env.ROOT_API
        const ENDPOINT = `v1/mysemeq-ambev/get-plants-online?region=${this.selected_region_on.value}`
        this.optionsOn = []
        let self = this
        axios({method: 'GET', url: API + ENDPOINT, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(resp => {
          var res = resp.data

          let cached_plant = self.getCachedFilter('planta_on')
          let option = undefined;

          var values = [{'text': 'All', 'value': ''}]
          for (var key in res) {           
            option = {'text': res[key].name, 'value': res[key].id}            

            if (res[key].id == cached_plant)
              self.selected_plants_online = option

            values.push(option)
          }

          self.optionsOn = values

          if(!self.selected_plants_online.text)
            self.selected_plants_online = values[0]

          if(self.initSearchOn && !self.getCachedFilter('area_f_on') && !self.getCachedFilter('sector_f_on') && !self.getCachedFilter('machine_on') && !self.getCachedFilter('subset_on')){
            self.searchOn()
          }

        })
        .catch(err => {
          // from mixin
          self.ApiErrorHandler(self, err.response.data.status_code);
        })
      },
      selected_plants_online: function(){
        const API = process.env.ROOT_API
        const ENDPOINT = `v1/mysemeq-ambev/get-area?id_plant=${this.selected_plants_online.value || ''}`
        this.optionsAreaOnline = []
        let self = this
        axios({method: 'GET', url: API + ENDPOINT, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(resp => {
          var res = resp.data

          let cached_area = self.getCachedFilter('area_f_on')
          let option = undefined;

          var values = [{'text': 'All', 'value': ''}]
          for (var key in res) {           
            option = {'text': res[key].familia_area, 'value': res[key].id_area}

            if(cached_area == option.value){
              self.selected_area_online = option;
              this.isClosedFilter = false;
            }

            values.push(option)
          }

          self.optionsAreaOnline= values

          if(!self.selected_area_online.text)
            self.selected_area_online = values[0]

          if(self.initSearchOn && !self.getCachedFilter('sector_f_on') && !self.getCachedFilter('machine_on') && !self.getCachedFilter('subset_on'))
              self.searchOn();
        })
        .catch(err => {
          // from mixin
          self.ApiErrorHandler(self, err.response.data.status_code);
        })

        //PARA PEGAR OS SETORES, somente com planta ativa, pois sem trava o sistema:
        if(this.selected_plants_online.value){
          this.active_sector = true
        
          const ENDPOINT_SECTOR = `v1/mysemeq-ambev/get-sector?id_plant=${this.selected_plants_online.value || ''}`
          //console.log('ENDPOINT_SECTOR: ', ENDPOINT_SECTOR)
          this.optionsSectorOnline = []
          axios({method: 'GET', url: API + ENDPOINT_SECTOR, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
          .then(resp => {
            var res = resp.data

            let cached_sector = self.getCachedFilter('sector_f_on')
            let option = undefined;

            var values = [{'text': 'All', 'value': ''}]
            for (var key in res) {   
              option = {'text': res[key].descricao_sector, 'value': res[key].descricao_sector}
              if(cached_sector == option.text){
                self.selected_sector_online = option;
                this.isClosedFilter = false;
              }

              values.push(option)
            }

            self.optionsSectorOnline = values

            if(!self.selected_sector_online.text)
              self.selected_sector_online = values[0]

            if(self.initSearchOn && !self.getCachedFilter('sector_f_on') && !self.getCachedFilter('machine_on') && !self.getCachedFilter('subset_on'))
                self.searchOn(); 
          })
          .catch(err => {
            // from mixin
            self.ApiErrorHandler(self, err.response.data.status_code);
          })

        }
        else{
          //console.log('desativa setor....')
          this.active_sector = false
        }


      },
      selected_area_online: function(){
        let self = this
        self.selected_machine_online = {'text': 'All', 'value': ''}
        this.optionsMachineOnline = []

        var area_id = this.selected_area_online.value

        const API = process.env.ROOT_API
        const ENDPOINT = `v1/mysemeq-ambev/get-conjunto?id_plant=${this.selected_plants_online.value}&id_area=${area_id}`
        this.optionsMachineOnline = []
        
        axios({method: 'GET', url: API + ENDPOINT, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(resp => {
          var res = resp.data

          let cached_machine = self.getCachedFilter('machine_on')
          let option = undefined;

          var values = [{'text': 'All', 'value': ''}]
          for (var key in res) {    
            option = {'text': res[key].familia_conjunto, 'value': res[key].id_conjunto}

            if(cached_machine == option.value){
              self.selected_machine_online = option
              this.isClosedFilter = false;
            }
            
            values.push(option)
          }

          self.optionsMachineOnline= values

          if(!self.selected_machine_online.text)
            self.selected_machine_online = values[0]

          if(self.initSearchOn && !self.getCachedFilter('sector_f_on') && !self.getCachedFilter('subset_on'))
            self.searchOn();
        })
        .catch(err => {
          // from mixin
          self.ApiErrorHandler(self, err.response.data.status_code);
        })
      },
      selected_machine_online: function(){

        let self = this
        self.selected_component_online = {'text': 'All', 'value': ''}
        this.optionsComponentOnline = []

        var area_id = this.selected_area_online.value
        var conj_id = this.selected_machine_online.value

        const API = process.env.ROOT_API
        const ENDPOINT = `v1/mysemeq-ambev/get-equipamento?id_plant=${this.selected_plants_online.value}&id_area=${area_id}&id_conj=${conj_id}`

        this.optionsComponentOnline = []
        
        axios({method: 'GET', url: API + ENDPOINT, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(resp => {
          var res = resp.data

          let cached_component = self.getCachedFilter('subset_on')
          let option = undefined;

          var values = [{'text': 'All', 'value': ''}]
          for (var key in res) {    
            option = {'text': res[key].familia_equipamento, 'value': res[key].id_equipamento}

            if(cached_component == option.value){
              self.selected_component_online = option
              this.isClosedFilter = false;
            }
            
            values.push(option)
          }

          self.optionsComponentOnline= values

          if(!self.selected_component_online.text)
            self.selected_component_online = values[0]

          if(self.initSearchOn)
            setTimeout(() => {
              self.searchOn();
            }, 5000);
        })
        .catch(err => {
          // from mixin
          self.ApiErrorHandler(self, err.response.data.status_code);
        })
      },
    }
  }
</script>
<style>

.collapsed {
  transition: opacity 1s;
}

.box-photo{
  text-align: center;
  height: 150px;
/*  border-bottom: 1px solid #545353;
  padding-bottom: 5px;*/
}
.box-photo img{
  width: 190px;
}
.more_filters{
  margin: 25px auto;
  color: #68b3c8;
  font-size: 14px;
  border: 1px solid #66615b;
  padding: 10px 5px;
}
.more_filters_title{
  height: 20px;
}
.more_filters_box{
  margin-top: 15px;
  color: #8f9a9a;
  font-size: 12px;
}
.info{
  /*width: 240px;
  height: 40px;*/
  text-align: center;
  margin-top: 15px;
  color: #fff;
  font-size: 11px;
}
.finter-online{
  padding: 10px 10px;
  color: #9d9a9a;
  font-size: 20px;
}
.filters{
  padding: 10px 10px;
  color: #9d9a9a;
  font-size: 20px;
}
.finter-campo{
  width: 100%;
  margin: 5px auto;
}
.finter-campo label{
  font-size: 14px;
}
.finter-bt{
  width: 240px;
  margin: 5px auto;
  height: 80px;
}
.finter-bt label{
  font-size: 14px;
}
select{
  color: #000;
  background-color: #ccc!important;
}
input{
  color: #000!important;
  background-color: #ccc!important;
}
.box-button{
  text-align: center;
  margin:2px 5px;
  float: left;
}
.box-button button{
  border: none;
  color: #ccc;
  padding: 10px 10px;
  background-color: #134f69;
  font-size: 15px;
}
.box-button button:hover{
  background-color: #042d3f;
}
.display_none{
  display: none;
}
.viewPeriod, .viewPeriodOnline{
  display: none;
}
.active{
  background-color:red;
}
.links{
  margin: 20px auto 5px auto;
  width: 200px;
  height: 80px;
  border-top: 1px solid #545353;
  padding-top: 35px;
}
.botao-link{
  width: 48%!important;
  border: none!important;
  color: #ccc!important;
  padding: 10px 10px!important;
  background-color: #134f69!important;
  font-size: 15px!important;
}

.botao-link:hover{
  background-color: #042d3f!important;
}

.botao-link a{
  color: #ccc!important;
}
.bt-search{
  width: 93%;
  margin: 0px auto;
}

.active3m, .active3mOnline{background-color: #627c88 !important;}
.active6m, .active6mOnline{background-color: #627c88 !important;}
.activetd, .activetdOnline{background-color: #627c88 !important;}
.active1y, .active1yOnline{background-color: #627c88 !important;}

.activeOff{background-color: #627c88 !important;}
.activeOn{background-color: #627c88 !important;}

.activeViewOff{display: none;}
.activeViewOn{display: none;}

.active {
  background-color: #627c88 !important;
}

.search{
  background-color: white !important;
  color: #000 !important;
}

.menu-config{
  /*height: 325px;*/
  height: auto;
  text-align: left;
  font-size: 12px;
  margin-top: 20px;
  color: #fff;
}
.sidebar-mini{
  margin-right: 10px;
}

.menu-config > li:hover{
  background-color: #3b3b3c;

}
.menu-config > li > a:hover{
  background-color: #5d5d5e!important;
  border-radius: 5px;

}

.img-slogan{
  text-align: center;
  border-bottom: 1px solid #545353;
  padding-bottom: 5px;
}
.img-slogan img{
  width: 80px;
}

.sidebar-normal-txt{
  margin-top:10px;
  font-size: 11px;
  color:#eee;
}

/* hint popover style */
div[data-popover="hint"] {
  background: #444 !important;
  color: #f9f9f9 !important;
  height: 30px !important;
  /* float: left !important; */
  position:fixed !important;
  /* margin-top: -720px !important; */
  margin-top: -5px !important;
  margin-left: 50px !important;
}

div[data-popover="hint"] p {
  font-size: 13px !important;
  margin-top: 2px !important;
  margin-left: 3px !important;
}

@media screen and (max-width: 420px) {
  .menu-config{
    height: 350px;
  }
  .ui.search.dropdown .menu {
    max-height: 800px!important;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/UserMenu.vue